import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import ClientSearchInput from '../atoms/ClientSearchInput'
import PrimaryButton from '../atoms/PrimaryButton'
import PlusSvg from '../other/svg/PlusSvg'
import RefreshSvg from '../other/svg/RefreshSvg'
import { FETCH_CLIENTS } from 'src/redux/clientsReducer'

interface ClientsFilterBarProps {
  onAddClient: () => void
}

const ClientsFilterBar = ({ onAddClient }: ClientsFilterBarProps): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <div className="self-stretch flex flex-col justify-start items-start">
      <div className="self-stretch h-14 min-h-14 bg-Estigroup-primary rounded-tl-lg rounded-tr-lg border-l border-r border-t border-neutral-200 flex flex-col justify-start items-center">
        <div className="self-stretch flex-1 px-4 py-3 inline-flex justify-start items-center gap-2 overflow-hidden">
          <div className="flex-1 flex justify-start items-center gap-3">
            <div className="justify-start text-foregrounds-fg-on-color text-xl font-semibold font-Montserrat">
              {t('clients.title')}
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch px-4 py-3 bg-backgrounds-bg-field-component rounded-bl-lg rounded-br-lg border-l border-r border-b border-neutral-200 inline-flex justify-start items-center gap-3">
        <div className="flex-1 inline-flex flex-col justify-start items-start">
          <div className="self-stretch h-9" />
        </div>
        <div className="flex justify-start items-center gap-3">
          <ClientSearchInput />
          <button
            type="button"
            onClick={() => {
              dispatch(FETCH_CLIENTS())
            }}
            className="w-10 h-10 p-2 bg-buttons-button-neutral rounded-md flex justify-center items-center overflow-hidden"
            style={{
              boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
            }}>
            <RefreshSvg className="w-3.5 h-3.5" />
          </button>
        </div>
        <PrimaryButton onClick={onAddClient} icon={<PlusSvg className="w-3.5 h-3.5 text-buttons-text-primary" />}>
          {t('clients.add_client')}
        </PrimaryButton>
      </div>
    </div>
  )
}

export default ClientsFilterBar
